import { Component, EventEmitter, Input, Output } from '@angular/core';
import { UiTableFilter, UiToolbarAction } from '../../models/ui-table.model';

export type UiToolbarLayout = 'default' | 'stacked';

@Component({
  selector: 'app-ui-table-toolbar',
  templateUrl: './ui-table-toolbar.component.html',
  styleUrls: ['./ui-table-toolbar.component.scss']
})
export class UiTableToolbarComponent {
  @Input() title = '';
  @Input() subtitle = '';
  @Input() searchPlaceholder = 'Search...';
  @Input() searchValue = '';
  @Input() filters: UiTableFilter[] = [];
  @Input() showExport = true;
  @Input() showCreate = true;
  @Input() createLabel = 'Create';
  @Input() showReset = false;
  @Input() resetLabel = 'Reset';
  @Input() searchLabel = 'Search';
  @Input() layout: UiToolbarLayout = 'default';
  @Input() secondaryActions: UiToolbarAction[] = [];
  @Output() search = new EventEmitter<string>();
  @Output() filterChange = new EventEmitter<{ key: string; value: string }>();
  @Output() export = new EventEmitter<void>();
  @Output() create = new EventEmitter<void>();
  @Output() reset = new EventEmitter<void>();
  @Output() secondaryAction = new EventEmitter<string>();

  get visibleSecondaryActions(): UiToolbarAction[] {
    return (this.secondaryActions || []).filter(a => a && a.visible !== false);
  }

  get isStacked(): boolean {
    return this.layout === 'stacked';
  }

  onSearchValueChange(value: string): void {
    this.searchValue = value;
  }

  onSearch(value?: string): void {
    if (value !== undefined) {
      this.searchValue = value;
    }
    this.search.emit(this.searchValue);
  }

  onFilterChange(key: string, value: string): void {
    this.filterChange.emit({ key, value });
  }

  onExport(): void {
    this.export.emit();
  }

  onCreate(): void {
    this.create.emit();
  }

  onReset(): void {
    this.reset.emit();
  }

  onSecondaryAction(id: string): void {
    this.secondaryAction.emit(id);
  }
}
